export const CompanyAnnounceRouting = [
  {
    path: "/information-manage/company-announce/list",
    name: "company-announce-list",
    meta: { title: "企业公告" },
    component: () => import("@/views/information-manage/company-announce/list/index.vue"),
  },
  {
    hidden: true,
    path: "/information-manage/company-announce/create",
    name: "company-announce-create",
    meta: { title: "新增企业公告",comName:"informationManageCompanyAnnounceFormCreate" },
    component: () => import("@/views/information-manage/company-announce/form-create/index.vue"),
  },
  {
    hidden: true,
    path: "/information-manage/company-announce/edit/:id",
    name: "company-announce-edit",
    meta: { title: "编辑企业公告",comName:"informationManageCompanyAnnounceFormCreate" },
    component: () => import("@/views/information-manage/company-announce/form-create/index.vue"),
  },
  {
    hidden: true,
    path: "/information-manage/company-announce/detail/:id",
    name: "company-announce-detail",
    meta: { title: "企业公告详情" },
    component: () => import("@/views/information-manage/company-announce/form-detail/index.vue"),
  },
];
